var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#0C3F6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2626 8.30671C17.569 8.61312 17.569 9.10992 17.2626 9.41633L10.9857 15.6932C10.6793 15.9997 10.1825 15.9997 9.87608 15.6932L6.73762 12.5548C6.43121 12.2484 6.43121 11.7516 6.73762 11.4452C7.04403 11.1388 7.54082 11.1388 7.84723 11.4452L10.4309 14.0288L16.153 8.30671C16.4594 8.0003 16.9562 8.0003 17.2626 8.30671Z",
    fill: "#0AE8F9",
    stroke: "#0C3F6D",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.48cd64e4be37abd927ca6f1b6fc8feda.svg";
export { ForwardRef as ReactComponent };